import Cookies from 'js-cookie';

export default () => Cookies.get('xo-session-token');
